$(function () {
    if ($("#rd-section-c1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-c2").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c2",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c2").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-c3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c3").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-c4").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c4",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c4").addClass("ani_fadein").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-c5").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c5",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c5").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-c6").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c6",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c6").addClass("ani_fadein").removeClass("op0");
            },
        });
    }
    let activitySwiper = new Swiper(".culture_swiper", {
        loop: true,
        navigation: {
            nextEl: ".idx_arrow.next",
            prevEl: ".idx_arrow.prev",
        },
        on: {
            slideChange: function () {
                let currentIndex = this.realIndex;
                $(".rd_activity_month").removeClass("now");
                $(`.rd_activity_month[data-silde="${currentIndex}"]`).addClass(
                    "now"
                );
                $(".rd_activity_swiper_slide").each(function () {
                    $(this).find(".rd_activity_item").removeClass("now");

                    let rdActivityItem = $(this).find(
                        ".rd_activity_item:first"
                    );
                    rdActivityItem.addClass("now");
                    $(this)
                        .find(".rd_activity_pic")
                        .attr("src", rdActivityItem.data("pic"));
                    $(this)
                        .find(".rd_activity_name")
                        .text(rdActivityItem.data("name"));
                    $(this)
                        .find(".rd_activity_description")
                        .html(rdActivityItem.data("description"));
                });
            },
        },
    });

    if ($(".rd_activity_month.now").length) {
        activitySwiper.slideTo($(".rd_activity_month.now").data("silde"));
    }

    $(".rd_activity_month").on("click", function () {
        $(".rd_activity_month").removeClass("now");
        $(this).addClass("now");
        activitySwiper.slideTo($(this).data("silde"));
    });

    $(".rd_activity_item").on("click", function () {
        let rdActivitySwiperSlide = $(this).closest(
            ".rd_activity_swiper_slide"
        );

        rdActivitySwiperSlide.find(".rd_activity_item").removeClass("now");
        $(this).addClass("now");

        rdActivitySwiperSlide
            .find(".rd_activity_pic")
            .attr("src", $(this).data("pic"));
        rdActivitySwiperSlide
            .find(".rd_activity_name")
            .text($(this).data("name"));
        rdActivitySwiperSlide
            .find(".rd_activity_description")
            .html($(this).data("description"));
    });

    $(".rd_brand_category").on("click", function () {
        $(".rd_brand_category").removeClass("now");
        let t = $(this);
        $("#rd_ajax_brand").load(
            $("#rd_ajax_brand").data("url"),
            {
                id: $(this).data("id"),
            },
            function (responseTxt, statusTxt, xhr) {
                if (statusTxt != "success") {
                    if (xhr.status == 419 || xhr.status == 500) {
                        $("#rd_confirm_dialog").removeClass("d_n");
                    }
                } else {
                    let brandItemFirst = $(
                        ".rd_brand_item.rd_brand_item_now:first"
                    );
                    if (brandItemFirst) {
                        $("#rd_brand_item_pic").attr(
                            "src",
                            brandItemFirst.data("pic")
                        );
                        $("#rd_brand_item_name").html(
                            `${brandItemFirst.data(
                                "pic_name"
                            )}<br />${brandItemFirst.data("pic_description")}`
                        );
                    }
                    t.addClass("now");
                }
            }
        );
    });
    let brandItemFirst = $(".rd_brand_item.rd_brand_item_now:first");
    if (brandItemFirst) {
        $("#rd_brand_item_pic").attr("src", brandItemFirst.data("pic"));
        $("#rd_brand_item_name").html(
            `${brandItemFirst.data("pic_name")}<br />${brandItemFirst.data(
                "pic_description"
            )}`
        );
    }

    $("#rd_ajax_brand").on("click", ".rd_brand_item", function () {
        $(".rd_brand_item")
            .removeClass("rd_brand_item_now")
            .removeClass("not_exist");
        $(this).addClass("rd_brand_item_now").addClass("not_exist");
        $("#rd_brand_item_pic").attr("src", $(this).data("pic"));
        $("#rd_brand_item_name").html(
            `${$(this).data("pic_name")}<br />${$(this).data(
                "pic_description"
            )}`
        );
    });

    let brandSwiper = new Swiper(".pop_swiper", {
        loop: true,
        navigation: {
            nextEl: ".swiper_btn.next",
            prevEl: ".swiper_btn.prev",
        },
    });

    $("#rd_ajax_brand").on("click", "#rd_brand_pop_open", function () {
        lockScroll($("body"));
        let silde = $(".rd_brand_item_now.not_exist").data("silde");
        brandSwiper.destroy();
        brandSwiper = new Swiper(".pop_swiper", {
            loop: true,
            navigation: {
                nextEl: ".swiper_btn.next",
                prevEl: ".swiper_btn.prev",
            },
            on: {
                slideChange: function () {
                    let currentIndex = this.realIndex;
                    let t = $(`.rd_brand_item[data-silde="${currentIndex}"]`);
                    $(".rd_brand_item")
                        .removeClass("rd_brand_item_now")
                        .removeClass("not_exist");
                    t.addClass("rd_brand_item_now").addClass("not_exist");
                    $("#rd_brand_item_pic").attr("src", t.data("pic"));
                    $("#rd_brand_item_name").html(
                        `${t.data("pic_name")}<br />${t.data(
                            "pic_description"
                        )}`
                    );
                    $(".rd_brand_has_img_item").each(function () {
                        $(this)
                            .find(".rd_brand_has_img_item_button")
                            .removeClass("now");
                        let t = $(this).find(
                            ".rd_brand_has_img_item_button:first"
                        );
                        if (t) {
                            t.addClass("now");
                            t.closest(".rd_brand_has_img_item")
                                .find(".rd_brand_has_img_item_description")
                                .html(t.data("description"));
                        }
                    });
                },
            },
        });
        brandSwiper.slideTo(silde);
        $("#rd_brand_pop").removeClass("d_n");
    });

    $("#rd_ajax_brand").on(
        "click",
        ".rd_brand_has_img_item_button",
        function () {
            let item = $(this).closest(".rd_brand_has_img_item");
            item.find(".rd_brand_has_img_item_button").removeClass("now");
            $(this).addClass("now");
            item.find(".rd_brand_has_img_item_description").html(
                $(this).data("description")
            );
        }
    );

    $("#rd_ajax_brand").on("click", "#rd_brand_pop_close", function () {
        unlockScroll($("body"));
        $("#rd_brand_pop").addClass("d_n");
    });
});
